import { useCallback, useMemo } from 'react';

import { RemoveLocationButton, UpsertLocationButton } from 'contacts/components';
import { MergeLocationsButton } from 'contacts/components/LocationList';
import { ContactGroupType } from 'contacts/enums';
import { IContactGroup, IContactGroupAddress } from 'contacts/types';
import { AgGridTable } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';

interface IProps {
  contactGroup: IContactGroup;
  contactGroupType: ContactGroupType;
}

export const ContactGroupLocationListTable = ({ contactGroup, contactGroupType }: IProps) => {
  const { selectedRows, updateRows } = useAgGridClientTableContext();

  const onMergeLocationsSuccess = useCallback(
    (updatedLocation: IContactGroupAddress) => {
      const removedLocation = selectedRows.find(
        (location) => location.addressId !== updatedLocation.addressId
      );

      updateRows({
        update: [updatedLocation],
        remove: [removedLocation],
      });
    },
    [selectedRows, updateRows]
  );

  const actionButtons = useCallback(() => {
    return [
      <UpsertLocationButton
        contactGroup={contactGroup}
        contactGroupType={contactGroupType}
        key="addLocationButton"
      />,
    ];
  }, [contactGroup, contactGroupType]);

  const selectionActionButtons = useMemo(() => {
    return [
      <MergeLocationsButton
        key="mergeLocationsButton"
        contactGroupType={contactGroupType}
        onSubmitSuccess={onMergeLocationsSuccess}
      />,
      <RemoveLocationButton
        key="removeLocationButton"
        locations={selectedRows}
        onSubmitSuccess={() => updateRows({ remove: selectedRows })}
        notificationPosition={NotificationPosition.TOP}
      />,
    ];
  }, [contactGroupType, onMergeLocationsSuccess, selectedRows, updateRows]);

  return (
    <AgGridTable actionButtons={actionButtons} selectionActionButtons={selectionActionButtons} />
  );
};
